import { observable, computed } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import useMouseDrag from './hooks/use-mouse-drag';
// import Video from '@src/components/video';

/** 游戏特色 */
class CharacteristicsStore extends BaseStore {
  constructor({ mainStore }) {
    super();
    this.mainStore = mainStore;
  }
  /** 容器 ref */
  containerRef = null;
  @observable mainStore = {};
  /** 当前是否为游戏特色页 */
  @computed
  get isActive() {
    return this.mainStore.pageChangeStore.currentPage === 'characteristics';
  }

  swiperStore = new BaseSwiperStore({
    swiperOptions: {
      centeredSlides: true,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      loop: true,
      loopedSlides: 3,
      allowTouchMove: false,
      slideToClickedSlide: true
    }
  });
  use() {
    this.containerRef = useMouseDrag(this.swiperStore);
  }
}

export default CharacteristicsStore;
